import getLatitude from '@commons/models/LocationPoint/getters/getLatitude';
import getLongitude from '@commons/models/LocationPoint/getters/getLongitude';
import getId from '@commons/models/LocationPoint/getters/getId';

export default function isValidCartAddress(address) {
  return getId(address) || (getLatitude(address) && getLongitude(address));
}
